import { render, staticRenderFns } from "./PackDealItem.vue?vue&type=template&id=57e75999&scoped=true&"
import script from "./PackDealItem.vue?vue&type=script&lang=js&"
export * from "./PackDealItem.vue?vue&type=script&lang=js&"
import style0 from "./PackDealItem.vue?vue&type=style&index=0&id=57e75999&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e75999",
  null
  
)

export default component.exports